export default "__VITE_ASSET__B3klf$lG__"